import { render, staticRenderFns } from "./noticeEdit.vue?vue&type=template&id=0f989f97&scoped=true&"
import script from "./noticeEdit.vue?vue&type=script&lang=js&"
export * from "./noticeEdit.vue?vue&type=script&lang=js&"
import style0 from "./noticeEdit.vue?vue&type=style&index=0&id=0f989f97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f989f97",
  null
  
)

export default component.exports